<script>
import Prism from 'prismjs';
Prism.highlightAll()

export default { 
  computed: {
    formattedMessage: function () {
      if (this.format === "json") {
        try {
          return Prism.highlight(JSON.stringify(JSON.parse(this.message), null, 2), Prism.languages.json, 'json');
        } catch (e) {
          console.log('Formatting error', e)
          // Do not format non-JSON values.
        }
      }

      return null;
    }
  },
  data() {
    return {
      message_classes: ['left-align', 'code-font', 'base01'],
    }
  },
  props: {
    message: String,
    format: {
      type: String,
      default: "json",
    },
    raw: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <div class="card base3">
    <div class="card-content">
      <span class="card-title" v-bind:class="{'title-error': error, 'title-success': !error, 'activator': raw}">{{title}}
        <i v-if="raw" class="material-icons right">more_vert</i>
      </span>
      <div v-if="formattedMessage">
        <pre v-html="formattedMessage" v-bind:class="message_classes">{{formattedMessage}}</pre>
      </div>
      <div v-else>
        <pre v-bind:class="message_classes">{{message}}</pre>
      </div>
    </div>
    <div v-if="raw" class="card-reveal base3">
      <span class="card-title">Raw Message<i class="material-icons right">close</i></span>
      <pre v-bind:class="message_classes">{{raw}}</pre>
    </div>
  </div>
</template>
